import React, { useEffect, useState } from "react";
import EmpContractTemplate from "./EmpContractTemplate";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { all_routes } from "Router/all_routes";
import { BackIcon } from "Components/UI/Icon/Icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PlusCircle } from "react-feather";
import { toast } from "core/Operations/toast";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  useInsertContractPolicyMutation,
  useGetContractVariablesQuery,
  useGetContractPoliciesQuery,
  useGetContractPolicyByIdQuery,
} from "AppQuries/master/ContractTemplate/contract-template";
import { useSelector } from "react-redux";
import { isContentEmpty } from "core/Operations/utils";

const CreateContractTemplate = () => {
  const [isMount, setIsMount] = useState(false);
  const { code } = useParams();
  const userData = useSelector(loggedInUser);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const navigate = useNavigate();
  const { data: templateData } = useGetContractPolicyByIdQuery({
    companyCode: userData?.companyCode,
    code,
  });
  const { mutate: saveContractTemplate } = useInsertContractPolicyMutation();
  const { data: variables, isLoading } = useGetContractVariablesQuery();

  const SaveContractTemplate = () => {
    console.log(title);
    if (!title.trim()) {
      toast.warning("Title cannot be empty");
      return;
    }
    if (!content || isContentEmpty(content)) {
      toast.warning("Contract content cannot be empty");
      return;
    }

    const requestData = new FormData();
    const payload = {
      id: templateData?.id || 0,
      title : title,
      companyCode: templateData?.companyCode || userData?.companyCode,
      createUser: templateData?.userName,
      createDate: templateData?.createDate || getCurrentFormattedDate(),
      modifyUser: userData?.userName,
      modifyDate: getCurrentFormattedDate(),
    };
    requestData.append("data", JSON.stringify(payload));
    requestData.append("description", content);

    saveContractTemplate(requestData, {
      onSuccess: (data) => {
        if (data?.response) {
          toast.success(
            data?.message || "Contract template saved successfully",
          );
          navigate(`${all_routes.contract_template}`);
        } else {
          toast.warning(data?.message || "Failed to save contract template");
        }
      },
      onError: (error) => {
        toast.error("Error saving contract template:", error.message || error);
      },
    });
  };

  useEffect(() => {
    if (templateData ) {
      setContent(templateData?.description || "");
      setTitle(templateData?.title || "");
    }
    setIsMount(true);
  }, [templateData]);

  return (
    <div className="page-wrapper cardhead">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Contract Template</h4>
              <h6>Create employee contract template</h6>
            </div>
          </div>

          <div className="page-btn" style={{ display: "flex" }}>
            {/* <Can
              accessModule={accessCodes.master}
              accessCode={accessCodes.master_contractType}
              accessType="haveAdd"
            > */}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Update</Tooltip>}
            >
              <Link
                to="#"
                className="btn btn-added"
                onClick={SaveContractTemplate}
              >
                <PlusCircle className="me-2" />
                Update
              </Link>
            </OverlayTrigger>
            {/* </Can> */}
            &nbsp;
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
            >
              <Link
                to={`${all_routes.contract_template}`}
                className="btn btn-secondary"
              >
                <BackIcon className="me-2" />
                Back
              </Link>
            </OverlayTrigger>
          </div>
        </div>

        <div className="row">
          <div className="card border-0">
            <div className="card-body">
              <EmpContractTemplate
                content={content}
                setContent={setContent}
                variables={variables}
                isLoading={isLoading}
                title={title}
                setTitle={setTitle}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateContractTemplate;
